(function (root, factory) {
  const createRegistry = factory();
  if (typeof module === 'object' && module.exports) module.exports = { createRegistry };
  if (typeof document === 'undefined') return;
  try {
    const payload = JSON.parse(document.getElementById('rwady-brand-alias-data')?.textContent || 'null');
    if (payload?.complete !== true || !Array.isArray(payload.entries)) return;
    root.RwadyBrandAliases = createRegistry(payload.entries);
  } catch (_) {
    // Preserve existing search if data is unavailable or invalid.
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  const fold = value => String(value ?? '').normalize('NFKC').toLowerCase()
    .replace(/[\u064B-\u065F\u0670\u0640]/g, '').replace(/[أإآٱ]/g, 'ا')
    .replace(/ى/g, 'ي').replace(/\s+/g, ' ').trim();
  const escape = value => value.replace(/[.*+?^$()|[\]\\{}]/g, '\\$&');
  return function createRegistry(entries) {
    const aliases = new Map();
    for (const entry of entries) {
      if (!entry || typeof entry.vendor !== 'string' || !entry.vendor.trim() ||
          !Array.isArray(entry.aliases) || entry.aliases.some(alias => typeof alias !== 'string')) {
        throw new Error('Invalid brand alias entry');
      }
      for (const value of [entry.vendor, entry.arabic_name, ...entry.aliases]) {
        const key = fold(value);
        if (!key) continue;
        if (!aliases.has(key)) aliases.set(key, new Set());
        aliases.get(key).add(entry.vendor);
      }
    }
    const unambiguous = [...aliases].filter(([, vendors]) => vendors.size === 1)
      .sort(([a], [b]) => b.length - a.length);
    const pattern = unambiguous.length ? new RegExp(
      '(^|[^\\p{L}\\p{N}])(' + unambiguous.map(([alias]) => escape(alias)).join('|') +
      ')(?=$|[^\\p{L}\\p{N}])', 'gu') : null;
    return {
      normalizeQuery(value) {
        if (!pattern) return String(value ?? '');
        return fold(value).replace(pattern, (_, boundary, alias) =>
          boundary + [...aliases.get(alias)][0]);
      },
      resolveBrand(value, allowedVendors, allowPrefix = false) {
        const key = fold(value);
        const allowed = new Set(allowedVendors);
        const exact = aliases.get(key);
        if (exact) {
          const values = [...exact].filter(vendor => allowed.has(vendor));
          return values.length === 1 ? values : [];
        }
        // Latin prefix recognition is opt-in; incomplete Arabic stays a general query.
        if (!allowPrefix || !/^[a-z][a-z0-9 ]{2,}$/.test(key)) return [];
        const candidates = [...allowed].filter(vendor => fold(vendor).startsWith(key));
        return candidates.length === 1 ? candidates : [];
      },
    };
  };
});
